// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refOperationalStateService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refOperationalStates/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refOperationalStates/${id}`).then(handleResponse);
}

function add(refOperationalState) {
    return axios.post('/refOperationalStates', refOperationalState).then(handleResponse);
}

function update(refOperationalState) {
    return axios.put(`/refOperationalStates/${refOperationalState.refOperationalStateId}`, refOperationalState).then(handleResponse);
}

function deleteEntity(refOperationalState) {
    return axios.delete(`/refOperationalStates/${refOperationalState.refOperationalStateId}`).then(handleResponse);
}
